<template>
  <div class="product" ref="product">
    <ul>
      <li>
        <img class="everyImg" :data-src="this.imageDict['0']" src="@/assets/images/pixel.png" />
      </li>
      <div ref="time_wrap" class="time_wrap">
        <div class="lunbo">
          <!-- 用户领取滚动  -->
          <SwiperView></SwiperView>
        </div>
        <div class="timer">
          <!-- 定时器组件 -->
          <TimeViewVue></TimeViewVue>
        </div>
      </div>
      <!-- 表单组件 -->
      <form-view @showData="showSuccess" :pageName="'ah'"></form-view>
      <li>
        <img class="everyImg" :data-src="this.imageDict['1']" src="@/assets/images/pixel.png" />
      </li>
      <div class="hot">
        <div><img src="@/assets/images/0.png" alt="" /></div>
        <!-- 热门推荐滚动 -->
        <div class="hot_swiper">
          <hot-swiper></hot-swiper>
        </div>
      </div>
      <li>
        <img class="everyImg" :data-src="this.imageDict['2']" src="@/assets/images/pixel.png" />
      </li>
      <li>
        <img class="everyImg" :data-src="this.imageDict['3']" src="@/assets/images/pixel.png" />
      </li>
      <li>
        <img class="everyImg" :data-src="this.imageDict['4']" src="@/assets/images/pixel.png" />
      </li>
      <!-- 定向流量使用详情 -->
      <div class="use_detail">
        <p @click="showDetail">*详情内容请查看定向流量使用详情>></p>
      </div>
      <div>
        <van-action-sheet v-model="showDet" :closeable="false" title="免流范围：">
          <div class="content">
            <!-- 使用详情组件 -->
            <use-detail></use-detail>
          </div>
        </van-action-sheet>
      </div>
    </ul>

    <!-- 退出时弹出链接图 -->
    <van-popup v-model="showLink" class="link_wrap">
      <div><img src="@/assets/images/exitPopup.png" alt="" /></div>
      <a href="https://lk0405.zhonglianhuashu.com:42105/pages/product4.html?orderSource=1110&merchantId=10006&productId=343&buyNum=1"
        class="box"></a>
    </van-popup>
    <!-- 领取成功时的弹框图 -->
    <van-popup v-model="show" class="successImg">
      <div class="close" @click="closeImg"></div>
      <img v-lazy="this.successImg" alt="" :key="this.successImg" />
    </van-popup>

    <div class="jump" @click="jumpLink">
      <van-icon name="arrow-left" size="0.6rem" color="#fff" />
      <van-icon name="arrow" size="0.6rem" color="#aaa" />
    </div>
  </div>
</template>

<script>
import TimeViewVue from "@/components/compent/TimeView.vue";
import SwiperView from "../components/compent/SwiperView.vue";
import HotSwiper from "@/components/compent/HotSwiper.vue";
import FormView from "@/components/aproh/FormView.vue";
import UseDetail from "@/components/compent/UseDetail.vue";
import utils from "@/assets/js/utils.js";

export default {
  components: {
    TimeViewVue,
    SwiperView,
    HotSwiper,
    FormView,
    UseDetail,
  },
  data() {
    return {
      show: false,
      showLink: false,
      showDet: false,
      imageDict: {},
      successImg: null,
    };
  },
  methods: {
    // 显示成功领取框
    showSuccess(val) {
      this.show = val;
    },
    // 关闭成功领取框
    closeImg() {
      this.show = false;
    },
    //显示详情弹框
    showDetail() {
      this.showDet = true;
    },
    jumpLink() {
      this.showLink = true;
    },
  },
  mounted() {
    if (!utils.getQueryVariable("planId")) {
      this.$router.push({
        path: "/404",
      });
    }
    let domain =
      process.env.NODE_ENV === "production"
        ? ""
        : "http://192.168.101.112:1005";

    this.$axios
      .get(`/data/h5/planDetail?planId=${utils.getQueryVariable("planId")}`)
      .then((res) => {
        let { code, data } = res.data;
        let { imageSrc, linkTitle, openStatus } = data;
        let imageDict = {};
        if (code == 200) {
          for (const key in imageSrc) {
            imageDict[key] = domain + "/image_service" + imageSrc[key];
          }
          this.successImg = imageDict["5"];
          this.imageDict = imageDict;

          //图片懒加载
          utils.lazyLoad(".everyImg");
        }
        //   标题;
        if (linkTitle) {
          document.title = linkTitle;
        }
        if (!openStatus) {
          this.$router.push({
            path: "/404",
          });
        }
      });
    // 调用方法
    let track_id = utils.getQueryVariable("track_id");
    let convertId = utils.getQueryVariable("convertId");

    if (track_id) {
      // 去除顶部轮播 和 加页脚
      this.$refs.time_wrap.style.display = "none";
      this.$refs.footer.style.display = "block";
    } else if (convertId) {
      // 添加页脚
      this.$refs.footer.style.display = "block";
    }
    // 禁止浏览器缩放
    utils.onload();
    // 改变背景颜色
    let bgc = utils.getQueryVariable("bgc");
    if (bgc) {
      this.$refs.product.style.backgroundColor = "#" + bgc;
    } else {
      this.$refs.product.style.backgroundColor = "#1B1C16";
    }
  },
};
</script>

<style lang="scss" scoped>
.product {
  position: relative;
  // background-color: #1B1C16;
  padding-bottom: 1.4rem;
  font-family: -apple-system-font, Helvetica Neue, sans-serif;

  li {
    width: 100%;
  }

  img {
    width: 100%;
  }

  .time_wrap {
    width: 100%;
    height: 0.45rem;
    padding: 0.2rem 0;
    color: #fff;
    background-color: #f00;
    border-radius: 0.3rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.23rem !important;

    .lunbo {
      width: 82%;
      height: 0.3rem;
      overflow: hidden;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .timer {
      width: 4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      margin-left: -0.2rem;
    }
  }

  .hot {
    padding: 0 0.4rem;
  }

  .van-popup {
    background-color: transparent;
  }

  .successImg img {
    display: block;
    width: 7rem;
    height: 7rem;
  }

  .close {
    position: absolute;
    bottom: 0.45rem;
    width: 1.3rem;
    height: 0.5rem;
    left: 50%;
    border-radius: 7%;
    opacity: 0;
    transform: translateX(-60%);
    // border: 1px solid #f00;
  }

  .footer {
    width: 100%;
    height: 1rem;
    padding-bottom: 2.2rem;
    // background-color: #2f2d2e;
    text-align: center;

    p {
      margin: 0.1rem 0;
      color: #f1f2f4;
      letter-spacing: 0.02rem;
    }
  }

  .use_detail {
    p {
      width: 100%;
      text-align: center;
      padding-bottom: 1rem;
      color: #f1f2f4;
      text-decoration: underline;
      font-size: 0.2rem;
      margin-top: 0.6rem;
    }
  }

  .van-action-sheet {
    background-color: #fff;
    border-radius: 0;
    max-height: 50%;
    letter-spacing: 0.02rem;

    .van-action-sheet__header {
      text-align: start;
      margin-left: 0.32rem;
      font-weight: 600;
      font-size: 0.3rem;
    }

    .content {
      padding: 0 0.32rem 0.32rem;

      ::v-deep h4 {
        font-weight: 600;
        margin: 0.2rem 0;
      }
    }
  }

  .link_wrap {
    width: 6.5rem;
    height: 6.5rem;

    .box {
      display: block;
      width: 5.9rem;
      height: 5.6rem;
      border-radius: 0.2rem;
      position: absolute;
      top: 0.44rem;
      left: 0;
      margin-left: 0.26rem;
      // border: 1px solid red;
    }
  }

  .jump {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1rem;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background-color: #1b1c16;
  }
}
</style>
